/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { PaymentApiConfiguration } from '../payment-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PamPartnerNotificationRequestDtoDto } from '../models/pam-partner-notification-request-dto-dto';


/**
 * the Payment Notifications API
 */
@Injectable({
  providedIn: 'root',
})
export class PaymentNotificationsService extends BaseService {
  constructor(
    config: PaymentApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createPartnerPaymentNotification
   */
  static readonly CreatePartnerPaymentNotificationPath = '/payment/partner/notification';

  /**
   * Create partner payment notification
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPartnerPaymentNotification()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPartnerPaymentNotification$Response(params: {
    body: PamPartnerNotificationRequestDtoDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentNotificationsService.CreatePartnerPaymentNotificationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Create partner payment notification
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPartnerPaymentNotification$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPartnerPaymentNotification(params: {
    body: PamPartnerNotificationRequestDtoDto
  },
  context?: HttpContext

): Observable<void> {

    return this.createPartnerPaymentNotification$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
